var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VueQuillEditor from 'vue-quill-editor/src/editor.vue';
import UiSimpleEditorToolbar from './UiSimpleEditorToolbar.vue';
var UiRichTextEditor = /** @class */ (function (_super) {
    __extends(UiRichTextEditor, _super);
    function UiRichTextEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contents = null;
        _this.quillOptions = {
            modules: {
                toolbar: _this.withToolbar ? '#rich-editor-toolbar' : false,
                clipboard: {
                    matchVisual: false,
                },
            },
            formats: (_this.withToolbar ? null : ['TemplatePlaceholderEmbed']),
            placeholder: '',
            theme: 'snow',
        };
        _this.quill = null;
        return _this;
    }
    UiRichTextEditor.prototype.created = function () {
        this.quillOptions.placeholder = this.placeholder;
    };
    UiRichTextEditor.prototype.onReady = function (quill) {
        this.quill = quill;
        if (this.withToolbar) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.$refs.toolbar.setQuill(quill);
        }
        this.$emit('onEditorReady', quill);
    };
    UiRichTextEditor.prototype.onChange = function (ctx) {
        this.$emit('input', ctx.html);
        this.$emit('onEditorChange', ctx);
    };
    UiRichTextEditor.prototype.onValueChanged = function (value) {
        this.contents = value;
    };
    UiRichTextEditor.prototype.onDisabledChanged = function (disabled) {
        if (this.quill) {
            this.quill.enable(!disabled);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiRichTextEditor.prototype, "placeholder", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], UiRichTextEditor.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], UiRichTextEditor.prototype, "resizable", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], UiRichTextEditor.prototype, "withToolbar", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], UiRichTextEditor.prototype, "disabled", void 0);
    __decorate([
        Watch('value', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], UiRichTextEditor.prototype, "onValueChanged", null);
    __decorate([
        Watch('disabled', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], UiRichTextEditor.prototype, "onDisabledChanged", null);
    UiRichTextEditor = __decorate([
        Component({
            components: {
                VueQuillEditor: VueQuillEditor,
                UiSimpleEditorToolbar: UiSimpleEditorToolbar,
            },
        })
    ], UiRichTextEditor);
    return UiRichTextEditor;
}(Vue));
export default UiRichTextEditor;
